import { render, staticRenderFns } from "./LinkEntityToMeeting.vue?vue&type=template&id=27a126f4&scoped=true&"
import script from "./LinkEntityToMeeting.vue?vue&type=script&lang=js&"
export * from "./LinkEntityToMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a126f4",
  null
  
)

export default component.exports